import { useState } from 'react';
/**
 * Pure display component for slider blocks.
 * Desktop: horizontal grid. Mobile: swipeable carousel.
 * No editing UI. Safe to copy to frontend.
 */
export function SliderView({ slides }) {
    const [activeIndex, setActiveIndex] = useState(0);
    const validSlides = slides.filter(s => s.url);
    if (validSlides.length === 0)
        return null;
    const prev = () => setActiveIndex(i => (i - 1 + validSlides.length) % validSlides.length);
    const next = () => setActiveIndex(i => (i + 1) % validSlides.length);
    return (<div className="w-full">
      {/* Desktop: 橫排 */}
      <div className="hidden md:grid gap-3" style={{ gridTemplateColumns: `repeat(${validSlides.length}, 1fr)` }}>
        {validSlides.map((slide, i) => (<div key={i} className="aspect-video rounded-[8px] overflow-hidden">
            <img src={slide.url} alt={`Slide ${i + 1}`} className="w-full h-full object-cover" loading="lazy"/>
          </div>))}
      </div>

      {/* Mobile: 輪播 */}
      <div className="md:hidden relative">
        <div className="relative aspect-video overflow-hidden rounded-[8px]">
          {validSlides.map((slide, i) => (<div key={i} className={`absolute inset-0 transition-opacity duration-300 ${i === activeIndex ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
              <img src={slide.url} alt={`Slide ${i + 1}`} className="w-full h-full object-cover" loading="lazy"/>
            </div>))}
        </div>

        {validSlides.length > 1 && (<>
            <button className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full p-1 transition-colors" onClick={prev} aria-label="上一張">
              ‹
            </button>
            <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full p-1 transition-colors" onClick={next} aria-label="下一張">
              ›
            </button>
            <div className="flex justify-center gap-1.5 mt-2">
              {validSlides.map((_, i) => (<button key={i} className={`w-2 h-2 rounded-full transition-colors ${i === activeIndex ? 'bg-[#6b9080]' : 'bg-[#44413D]/30'}`} onClick={() => setActiveIndex(i)} aria-label={`第 ${i + 1} 張`}/>))}
            </div>
          </>)}
      </div>
    </div>);
}
